import { tuApptoAPI, getAuthHeaders, getErrorData } from './config'

const headers = getAuthHeaders().headers
export const findAll = async id => {
  try {
    const response = await tuApptoAPI.get(`/parkings/findall/${id}`, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const create = async request => {
  try {
    const response = await tuApptoAPI.post('/parkings/create', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const update = async request => {
  try {
    const response = await tuApptoAPI.put('/parkings/update', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const remove = async id => {
  try {
    const response = await tuApptoAPI.delete(`/parkings/remove/${id}`, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}
